import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AuthService } from '../../../services/auth.service';
import { SharedService } from "../../../services/shared.service";
import { FormBankComponent } from "../forms/bank/bank.component";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
const emails = require('../../../services/emails.json');
import { environment } from '../../../../environments/environment';
import { AngularFireStorage } from '@angular/fire/storage';
import * as moment from "moment-timezone";
import { CryptoService } from '../../../services/crypto.service';

@Component({
  selector: 'app-support-create',
  templateUrl: './create.component.html',
  styleUrls: ['./create.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class VTuberSupportCreateComponent implements OnInit {
  TYPE_PROFILE: string = 'プロフィール';
  TYPE_SUPPORT_PLAN: string = '支援プラン';
  TYPE_THANKS_MESSAGE: string = 'お礼メッセージ';
  TYPE_BANK_INFO: string = '銀行口座情報';
  types = [this.TYPE_PROFILE, this.TYPE_SUPPORT_PLAN, this.TYPE_THANKS_MESSAGE, this.TYPE_BANK_INFO];
  selectedInputType: string = this.TYPE_PROFILE;
  isSent: boolean = false;
  publicMessage: string = '';
  hasNoReviewChange: boolean = false;
  newUploadFiles: any[];
  newFileChanged: boolean = false;

  welcomeForm: any = {
    url: '',
    message: ''
  }

  fileObjs: any = {
    avatarFile: undefined,
    headerFile: undefined,
    vrmFile: undefined,
    file2048: [],
    filemoc: undefined,
    filemodel: undefined,
    filepose: undefined,
    filephysics: undefined,
    isCompleted: false,
    uploadFile2048: [],
    isLinkFailed: false
  }

  profileForm: any = {
    name: '',
    title: '',
    description: '',
    photoURL: '',
    headerURL: '',
    modelType: 'live2d',
    twitter_url: '',
    youtube_url: '',
    showSocialLink: false,
    vrm: undefined,
    live2d: undefined
  }

  plans: any[];

  bankForm: any = {
    bank_name: '',
    branch_code: '',
    account_type: FormBankComponent.ACCOUNT_TYPE_NORMAL,
    account_number: '',
    account_name: ''
  }

  constructor(
    public auth: AuthService,
    private modalService: NgbModal,
    private shared: SharedService,
    private afStorage: AngularFireStorage,
    private crypto: CryptoService
  ) {}

  ngOnInit() {
    this.refreshData();

    window.scrollTo(0, 0);
  }

  refreshData() {
    this.welcomeForm = {
      url: this.auth.user.welcome ? this.auth.user.welcome.url : '',
      message: this.auth.user.welcome ? this.auth.user.welcome.message : ''
    }

    this.profileForm.name = this.auth.user.displayName;
    this.profileForm.photoURL = this.auth.user.photoURL
    this.profileForm.title = this.auth.user.profile && this.auth.user.profile.title ? this.auth.user.profile.title : ''
    this.profileForm.description = this.auth.user.profile && this.auth.user.profile.description ? this.auth.user.profile.description : ''
    this.profileForm.headerURL = this.auth.user.profile && this.auth.user.profile.headerURL ? this.auth.user.profile.headerURL : ''
    this.profileForm.modelType = this.auth.user.profile && this.auth.user.profile.modelType ? Object.assign({}, this.auth.user.profile).modelType : 'live2d'
    this.profileForm.twitter_url = this.auth.user.twitter_url ? this.auth.user.twitter_url : ''
    this.profileForm.youtube_url = this.auth.user.youtube_url ? this.auth.user.youtube_url : ''
    this.profileForm.showSocialLink = this.auth.user.showSocialLink ? this.auth.user.showSocialLink : false;
    this.profileForm.vrm = this.auth.user.profile && this.auth.user.profile.vrm ? this.auth.user.profile.vrm : {filename: '', url: ''};
    this.profileForm.live2d = this.auth.user.profile && this.auth.user.profile.live2d ? this.auth.user.profile.live2d : {
      file2048: [{filename: '', url: ''}],
      filemoc: {filename: '', url: ''},
      filemodel: {filename: '', url: ''},
      filepose: {filename: '', url: ''},
      filephysics: {filename: '', url: ''}
    };
    this.profileForm.live2d.file2048 = this.profileForm.live2d.file2048 ? this.profileForm.live2d.file2048 : [{filename: '', url: ''}]
    this.profileForm.live2d.filemoc = this.profileForm.live2d.filemoc ? this.profileForm.live2d.filemoc : {filename: '', url: ''}
    this.profileForm.live2d.filemodel = this.profileForm.live2d.filemodel ? this.profileForm.live2d.filemodel : {filename: '', url: ''}
    this.profileForm.live2d.filepose = this.profileForm.live2d.filepose ? this.profileForm.live2d.filepose : {filename: '', url: ''}
    this.profileForm.live2d.filephysics = this.profileForm.live2d.filephysics ? this.profileForm.live2d.filephysics : {filename: '', url: ''}

    this.fileObjs.file2048 = this.profileForm.live2d.file2048.map(item => undefined)

    this.plans = this.auth.user.plans ? this.auth.user.plans : [];

    this.decrypt()
  }

  canSendReview() {
    if (this.profileForm.name === '' || this.profileForm.title === '' || this.profileForm.description === ''
    || this.profileForm.photoURL === '' || this.profileForm.headerURL === '' || this.plans.length === 0 || this.welcomeForm.message === '' || this.bankForm.bank_name === '' || this.bankForm.branch_code === ''
    || this.bankForm.account_type === '' || this.bankForm.account_number === '' || this.bankForm.account_name === '') {
      return false;
    }

    return true
  }

  getTypeDescription() {
    switch (this.selectedInputType) {
      case this.TYPE_PROFILE:
        return '支援ページに表示する自己紹介やプロフィール画像を設定しましょう。'
      case this.TYPE_SUPPORT_PLAN:
        return '各プランの内容や金額、上限人数などの詳細を設定'
      case this.TYPE_THANKS_MESSAGE:
        // return '支援を開始した相手に送られるお礼メッセージと動画を設定'
        return '支援を開始した相手に送られるお礼メッセージを設定'
      case this.TYPE_BANK_INFO:
        return '集まった支援金を振り込む銀行口座情報を登録'
      default:
        return ''
    }

    return ''
  }

  needShow(type) {
    return this.selectedInputType === type
  }

  checkBankUpdates(params) {
    let bank = undefined
    if (this.auth.user.status === AuthService.VTUBER_COMPLETD_STATUS) {
      bank = Object.assign({}, this.auth.user.bank)
      if (bank === undefined) bank = {}
      delete bank.change
      delete this.bankForm.change
      bank.change = this.bankForm
    } else {
      bank = Object.assign({}, this.bankForm)
      if (bank === undefined) bank = {}
      delete bank.change
    }

    bank.account_name = this.crypto.encrypt(bank.account_name)
    bank.account_number = this.crypto.encrypt(bank.account_number)
    bank.account_type = this.crypto.encrypt(bank.account_type)
    bank.bank_name = this.crypto.encrypt(bank.bank_name)
    bank.branch_code = this.crypto.encrypt(bank.branch_code)

    params.bank = bank;

    return params
  }

  checkWelcomeUpdates(params) {
    params.welcome = this.welcomeForm
    return params
  }

  async checkProfileUpdates(params) {
    this.fileObjs.isCompleted = false;
    this.newUploadFiles = []
    this.newFileChanged = false;

    if (params.profile === undefined) params.profile = {}

    let newProfile: any = Object.assign({}, params.profile);
    delete newProfile.change

    params.profile.title = this.profileForm.title
    params.profile.description = this.profileForm.description
    params.displayName = this.profileForm.name
    params.twitter_url = this.profileForm.twitter_url
    params.youtube_url = this.profileForm.youtube_url
    params.showSocialLink = this.profileForm.showSocialLink

    newProfile.modelType = this.profileForm.modelType

    if (this.profileForm.modelType === 'vrm') {
      newProfile.vrm = this.profileForm.vrm ? this.profileForm.vrm : {}
      delete newProfile.live2d
    } else {
      newProfile.live2d = this.profileForm.live2d ? this.profileForm.live2d : {}
      delete newProfile.vrm
    }

    let files = []

    if (this.fileObjs.headerFile) {
      await this.uploadPhoto(this.fileObjs.headerFile, 'header_file');
      files.push({
        url: "/users/" + this.auth.user.uid + '/' + 'header_file',
        type: 'header_file'
      })
    }

    if (this.fileObjs.avatarFile) {
      await this.uploadPhoto(this.fileObjs.avatarFile, 'avatar');
      files.push({
        url: "/users/" + this.auth.user.uid + '/' + 'avatar',
        type: 'avatar'
      })
    }

    if (newProfile.modelType === 'vrm' && this.fileObjs.vrmFile) {
      await this.uploadPhoto(this.fileObjs.vrmFile, 'vrm_file');
      files.push({
        url: "/users/" + this.auth.user.uid + '/' + 'vrm_file',
        type: 'vrm_file',
        filename: this.profileForm.vrm.filename
      })

      this.newFileChanged = true;
    }

    if (newProfile.modelType === 'live2d' && this.fileObjs.file2048.length > 0) {
      files = await this.upload2048Files(files);
    }

    if (newProfile.modelType === 'live2d' && this.fileObjs.filemoc) {
      await this.uploadPhoto(this.fileObjs.filemoc, 'moc_file');
      files.push({
        url: "/users/" + this.auth.user.uid + '/' + 'moc_file',
        type: 'moc_file',
        filename: this.profileForm.live2d.filemoc.filename
      })
      this.newFileChanged = true;
    }

    if (newProfile.modelType === 'live2d' && this.fileObjs.filemodel) {
      await this.uploadPhoto(this.fileObjs.filemodel, 'model_file');
      files.push({
        url: "/users/" + this.auth.user.uid + '/' + 'model_file',
        type: 'model_file',
        filename: this.profileForm.live2d.filemodel.filename
      })
      this.newFileChanged = true;
    }

    if (newProfile.modelType === 'live2d' && this.fileObjs.filepose) {
      await this.uploadPhoto(this.fileObjs.filepose, 'pose_file');
      files.push({
        url: "/users/" + this.auth.user.uid + '/' + 'pose_file',
        type: 'pose_file',
        filename: this.profileForm.live2d.filepose.filename
      })
      this.newFileChanged = true;
    }

    if (newProfile.modelType === 'live2d' && this.fileObjs.filephysics) {
      await this.uploadPhoto(this.fileObjs.filephysics, 'physics_file');
      files.push({
        url: "/users/" + this.auth.user.uid + '/' + 'physics_file',
        type: 'physics_file',
        filename: this.profileForm.live2d.filephysics.filename
      })
      this.newFileChanged = true;
    }

    if (this.profileForm.live2d.filephysics.filename === undefined) {
      if (this.auth.user.profile && this.auth.user.profile.live2d && this.auth.user.profile.live2d.filephysics) {
        newProfile.live2d.filephysics = {
          filename: '',
          url: ''
        }
        this.newFileChanged = true;
      }
    }

    if (this.profileForm.live2d.filepose.filename === undefined) {
      if (this.auth.user.profile && this.auth.user.profile.live2d && this.auth.user.profile.live2d.filepose) {
        newProfile.live2d.filepose = {
          filename: '',
          url: ''
        }
        this.newFileChanged = true;
      }
    }

    if (this.profileForm.live2d.filemodel.filename === undefined) {
      if (this.auth.user.profile && this.auth.user.profile.live2d && this.auth.user.profile.live2d.filemodel) {
        newProfile.live2d.filemodel = {
          filename: '',
          url: ''
        }
        this.newFileChanged = true;
      }
    }

    if (this.profileForm.live2d.filemoc.filename === undefined) {
      if (this.auth.user.profile && this.auth.user.profile.live2d && this.auth.user.profile.live2d.filemoc) {
        newProfile.live2d.filemoc = {
          filename: '',
          url: ''
        }
        this.newFileChanged = true;
      }
    }

    if (this.profileForm.vrm.filename === undefined) {
      if (this.auth.user.profile && this.auth.user.profile.vrm) {
        newProfile.vrm.filename = {
          filename: '',
          url: ''
        }
        this.newFileChanged = true;
      }
    }

    if (files.length > 0) {
      if (newProfile.live2d && newProfile.live2d.file2048) {
        delete newProfile.live2d.file2048;
      }

      files
      .map((item, index) => {
        if (item.type === '2048_file') {
          if (newProfile.live2d.file2048 === undefined) {
            newProfile.live2d.file2048 = []
          }

          if (item.isNew === false) {
            newProfile.live2d.file2048.push({
              filename: item.filename,
              url: item.url
            })
          } else {
            newProfile.live2d.file2048.push({
              index: index
            })

            this.newUploadFiles.push(item)
          }
        } else {
          this.newUploadFiles.push(item)
        }
      })
      let fileDownloadsRes = await Promise.all(
        this.newUploadFiles
        .map((item, index) => {
        return this.afStorage.ref(item.url).getDownloadURL()
      }))

      fileDownloadsRes.map((res, index) => {
        res.subscribe(url => {
          if (this.newUploadFiles[index].type === 'header_file') {
            params.profile.headerURL = url
          } else if (this.newUploadFiles[index].type === 'avatar') {
            params.photoURL = url
          } else if (this.newUploadFiles[index].type === 'vrm_file') {
            newProfile.vrm = {
              filename: this.newUploadFiles[index].filename,
              url: url
            }
          } else if (this.newUploadFiles[index].type === 'moc_file') {
            newProfile.live2d.filemoc = {
              filename: this.newUploadFiles[index].filename,
              url: url
            }
          } else if (this.newUploadFiles[index].type === 'pose_file') {
            newProfile.live2d.filepose = {
              filename: this.newUploadFiles[index].filename,
              url: url
            }
          } else if (this.newUploadFiles[index].type === 'physics_file') {
            newProfile.live2d.filephysics = {
              filename: this.newUploadFiles[index].filename,
              url: url
            }
          } else if (this.newUploadFiles[index].type === 'model_file') {
            newProfile.live2d.filemodel = {
              filename: this.newUploadFiles[index].filename,
              url: url
            }
          } else if (this.newUploadFiles[index].type === '2048_file') {
            newProfile.live2d.file2048 = newProfile.live2d.file2048.map(item => {
              if (item.index === index) {
                return {
                  filename: this.newUploadFiles[index].filename,
                  url: url
                }
              }

              return item
            })
          }
        })
      })
    }

    if (this.auth.user.status === AuthService.VTUBER_COMPLETD_STATUS) {
      if (this.newFileChanged === true) {
        delete params.profile.change
        delete newProfile.description
        delete newProfile.headerURL
        delete newProfile.title
        params.profile.change = newProfile
        params.profile.change.status = 'draft'
      }
    } else {
      params.profile = newProfile
      params.profile.title = this.profileForm.title
      params.profile.description = this.profileForm.description
      params.displayName = this.profileForm.name
      params.twitter_url = this.profileForm.twitter_url
      params.youtube_url = this.profileForm.youtube_url
      params.showSocialLink = this.profileForm.showSocialLink
    }

    return params
  }

  doBankTempAction(params) {
    let newBankData = Object.assign({}, params)
    let change = Object.assign({}, newBankData.bank.change)
    delete change.status
    params.bank = change;

    delete params.bank.change

    params.bank.account_name = this.crypto.encrypt(params.bank.account_name)
    params.bank.account_number = this.crypto.encrypt(params.bank.account_number)
    params.bank.account_type = this.crypto.encrypt(params.bank.account_type)
    params.bank.bank_name = this.crypto.encrypt(params.bank.bank_name)
    params.bank.branch_code = this.crypto.encrypt(params.bank.branch_code)

    return params
  }

  doPlanTempAction(item) {
    if (item.status !== undefined) {
      delete item.status
      delete item.change

      return item
    }

    if (item.change !== undefined) {
      let hasSupporters = false;
      if (this.auth.user.supporters) {
        this.auth.user.supporters.filter(supporter => supporter.plan_uid === item.uid)
        .map(() => {
          hasSupporters = true;
        })
      }

      let today = moment().tz('Asia/Tokyo');
      let endOfMonth = moment().endOf('month').tz('Asia/Tokyo');
      let futureMonth = moment(today).add(1, 'M');

      if (today.date() > endOfMonth.date() - 3) {
        futureMonth = moment(futureMonth).add(1, "M");
      }

      if (hasSupporters) { // Has Supporters
        item.change.applyAt = futureMonth.format("Y-MM")
      } else {
        item.amount = item.change.amount
        item.description = item.change.description
        item.limit = item.change.limit
        item.period = item.change.period
        item.title = item.change.title
      }

      item.change.status = 'approve';

      return item;
    }

    return item;
  }

  async sendReview() {
    this.modalService.dismissAll();

    this.auth.toggleSpinner(true);
    if (this.auth.user.status !== AuthService.VTUBER_COMPLETD_STATUS) {
      let params = Object.assign({}, this.auth.user)
      params.status = AuthService.VTUBER_REVIEW_STATUS

      params = this.checkBankUpdates(params)
      params = this.checkWelcomeUpdates(params)
      params = await this.checkProfileUpdates(params)

      let self = this;
      let timeout = 10;
      if (this.newUploadFiles.length > 0) {
        timeout = 2000;
      }

      setTimeout(function() {
        self.auth.updateUserData(params, false)
        .then(() => {
          self.auth.getUser().then(res => {
            self.auth.setUser(res)

            self.plans = self.auth.user.plans;

            self.auth.toggleSpinner(false);
            self.isSent = true;

            setTimeout(function() {
              self.isSent = false;
            }, 3000);
          })
        })
      }, timeout);

      // Send Email
      this.auth.sendEmail({
        to: this.auth.user.email,
        subject: emails.support_profile_reivew_subject,
        text: this.auth.getEmailTemplate(emails.support_profile_reivew.join("")).replace(/\[VTuber名\]/g, this.auth.user.displayName)
      })
    } else {
      let params = Object.assign({}, this.auth.user)

      params = this.checkBankUpdates(params)
      params = this.checkWelcomeUpdates(params)
      params = await this.checkProfileUpdates(params)

      if (this.newFileChanged === true && params.profile.change !== undefined) {
        params.profile.change.status = "review"
      }

      if (params.profile.change !== undefined) {
        if (this.auth.user.profile.modelType !== params.profile.change.modelType) {
          this.newFileChanged = true
          params.profile.change.status = "review"
        }
      }

      params.plans = params.plans.map((item, index) => {
        // if (item.change && item.change.status === undefined) {
        //   item.change.status = 'review';
        // }

        // if (item.status && item.status === 'draft') {
        //   item.status = 'review';
        // }

        // Plans Temporarily Action
        item = this.doPlanTempAction(item)

        return item;
      })

      // Bank
      if (params.bank.change !== undefined && params.bank.change.status !== 'review') {
        params.bank.change.status = "review";
      }

      // Bank Temporarily Action
      params = this.doBankTempAction(params)

      let self = this;
      let timeout = 10;
      if (this.newUploadFiles.length > 0) {
        timeout = 2000;
      }

      setTimeout(function() {
        self.auth.updateUserData(params, false)
        .then(() => {
          self.auth.getUser().then(res => {
            self.auth.setUser(res)

            setTimeout(() => {
              self.refreshData()

              self.auth.toggleSpinner(false);

              self.hasNoReviewChange = true;
              self.sendPlanChangeEmail()

              setTimeout(function() {
                self.hasNoReviewChange = false;
              }, 5000);
            }, 100)
          })
        })
      }, timeout);
    }
  }

  sendPlanChangeEmail() {
    this.auth.sendProfileReview()
    this.newFileChanged = false;
  }

  changePublic() {
    let self = this;
    let params: any = {
      uid: this.auth.user.uid
    }
    if (this.auth.user.is_public === false) {
      params.is_public = true;
    } else {
      params.is_public = false;
    }

    this.auth.updateUserData(params)
    .then(() => {
      this.auth.fetchUser();

      if (params.is_public === false) {
        self.publicMessage = '支援ページが非公開になりました。'
      } else {
        self.publicMessage = '支援ページが公開になりました。'
      }

      setTimeout(function() {
        self.publicMessage = '';
      }, 3000);
    })
  }

  canChangePublic() {
    return this.auth.user.status === AuthService.VTUBER_COMPLETD_STATUS
  }

  openForSendConfirm(content) {
    this.modalService.open(content, { centered: true });
  }

  preview() {
    this.refreshData()
    this.shared.setCookie(SharedService.PREVIEW_SUPPORT_COOKIE, {
      profile: this.profileForm,
      welcome: this.welcomeForm,
      bank: this.bankForm,
      plans: this.plans
    })

    this.shared.redirect('/vtuber/support/preview', true);
  }

  async saveProfile() {
    this.auth.toggleSpinner(true);

    let params = Object.assign({}, this.auth.user)
    params = await this.checkProfileUpdates(params)

    let self = this;
    let timeout = 10;
    if (this.newUploadFiles.length > 0) {
      timeout = 2000;
    }

    setTimeout(function() {
      self.auth.updateUserData(params, false)
      .then(() => {
        self.auth.getUser().then(res => {
          self.auth.setUser(res)
          self.fileObjs.isCompleted = true;
          self.refreshData()
          self.auth.toggleSpinner(false);

          setTimeout(function() {
            self.fileObjs.isCompleted = false;
          }, 3000);
        })
      })
      .catch(error => {
        self.auth.toggleSpinner(false);
      })
    }, timeout);
  }


  async upload2048Files(files) {
    this.fileObjs.uploadFile2048 = []
    this.fileObjs.file2048.map((file, index) => {
      if (file === undefined) {
        if (this.profileForm.live2d.file2048[index].filename !== '') {
          this.fileObjs.uploadFile2048.push(this.profileForm.live2d.file2048[index])

          if (this.profileForm.live2d.file2048[index].filename === undefined) {
            this.newFileChanged = true;
          }
        }
      } else {
        this.fileObjs.uploadFile2048.push(index)
        this.newFileChanged = true;
      }
    })

    let newFiles = [];
    this.fileObjs.file2048.map(async (file, index) => {
      if (file !== undefined) {
        newFiles.push({
          file: file,
          index: index
        })
      }
    })

    let res = undefined
    if (newFiles.length > 0) {
      res = await Promise.all(newFiles.map((item, index) => this.uploadPhoto(item.file, '2048_file_' + item.index)))
    }

    this.fileObjs.uploadFile2048.map((item, index) => {
      if (!isNaN(item)) {
        if (res !== undefined) {
          res.map((file, ind) => {
            if (newFiles[ind].index === index) {
              files.push({
                url: "/users/" + this.auth.user.uid + '/' + '2048_file_' + newFiles[ind].index,
                type: '2048_file',
                index: newFiles[ind].index,
                isNew: true,
                filename: this.profileForm.live2d.file2048[newFiles[ind].index].filename
              })
            }
          })
        }
      } else {
        if (this.profileForm.live2d.file2048[index].filename === undefined || this.profileForm.live2d.file2048[index].filename === '') {
          return false;
        }

        files.push(Object.assign({
          type: '2048_file',
          index: index,
          isNew: false
        }, item))
      }
    })

    return files
  }

  uploadPhoto(file, filename) {
    let ref = this.afStorage.ref("/users/" + this.auth.user.uid + '/' + filename);
    let task = ref.put(file);

    return task
  }

  private decrypt() {
    this.bankForm = this.auth.user.bank ? Object.assign({}, this.auth.user.bank) : {
      bank_name: '',
      branch_code: '',
      account_type: FormBankComponent.ACCOUNT_TYPE_NORMAL,
      account_number: '',
      account_name: ''
    }
    this.bankForm.account_name = this.crypto.decrypt(this.bankForm.account_name)
    this.bankForm.account_number = this.crypto.decrypt(this.bankForm.account_number)
    this.bankForm.account_type = this.crypto.decrypt(this.bankForm.account_type)
    this.bankForm.bank_name = this.crypto.decrypt(this.bankForm.bank_name)
    this.bankForm.branch_code = this.crypto.decrypt(this.bankForm.branch_code)
  }
}
